import React, { useState, useEffect, memo, forwardRef } from "react";
import tw from "twin.macro";
import Topbar from "./Topbar.js";
import { PurityApi } from "../../api/PurityApi.js";
import { getAddToCart, getBranchId, getCustomerId, getCustomerName, removeCustomerId } from "utility/HeaderConfig.js";
import { Link, useNavigate } from "react-router-dom";
import "bootstrap/dist/js/bootstrap.bundle";
import { useCartContext } from "context/UseCartContext.js";
import toast, { Toaster } from "react-hot-toast";
import { reactLocalStorage } from "reactjs-localstorage";
import Noimg from "../../images/no_img.jpg";
import RemoveCart from "components/RemoveCart.js";
import { getProduct } from "api/ProductApi.js";
import moment from "moment";
import { filterFormatFromDate, filterFormatToDate } from "utility/Constant.js";
import { ECommerce } from "api/AppConfigApi.js";
import styled from "styled-components";
import cartImg from "../../cartblack.jpg"
import logo182 from "../../images/assets/logo182.svg"
import white from "../../images/assets/white.svg"
import accountImg from "../../images/assets/useraccount.jpeg";
import wishlistImg from "../../wishlistyellow.jpg";
import schemeImage from "../../images/assets/savingSchemeBorderedimage.png";
import { getAllBranch } from "api/BranchDetailsApi";
import { getPageProductType } from "api/ProductTypeApi";
import { ProductCateCountApi } from "api/ProductCategoryApi";
import { getAllProductSubCate } from "api/ProductSubCateApi";
import { getAllProductCate } from "api/ProductCategoryApi";
import { getProductCate } from "../../api/ProductCategoryApi";
import Logo from "../../images/assets/JaiMarutiJewelleryLogo.png";
import Logo2 from "../../images/assets/MayuriLogo_400-1 .png";
import findStore from "../../shopyellow.jpg";
import log2 from "../../images/assets/log2.png";
import logo187 from "../../images/assets/logo187.webp";
import { CATEGORY_lIST } from "../../utility/Constant";

export const NavLink = tw.span`my-2 tracking-wide transition duration-300 text-black hover:text-custom-100  pb-2 lg:pb-5 no-underline border-b-4 border-transparent hover:border-custom-100 text-base lg:text-sm lg:mx-4 lg:my-0 xl:text-base xl:mx-6`;

export const LogoLink = styled(NavLink)`
  ${tw`py-2`};
  img {
    ${tw`mr-3`}
  }
`;

const CartTitle = tw.div`text-xs tracking-widest font-semibold text-gray-700`;

const MyComponent = ({ branch }) => {
  const navigate = useNavigate();
  const [recentGoldRate, setRecentGoldRate] = useState({
    metaProdTypeName: "Gold",
    rate: "N/A",
    unitType: "",
  });
  const [recentSilverRate, setRecentSilverRate] = useState({
    metaProdTypeName: "Silver",
    rate: "N/A",
    unitType: "",
  });
  const [recentGold18KRate, setRecentGold18KRate] = useState({
    metaProdTypeName: "Gold",
    rate: "N/A",
    unitType: "",
  });
  const { data, branchId } = useCartContext();

  const fromAccount = true;
  // const { login } = useCartContext();

  const [isShow, setIsShow] = useState(false);
  const [modalOpened, setModalOpened] = useState(false);
  const [hoverPincode, setHoverPincode] = useState(false);
  const [showMap, setShowMap] = useState(false);
  const [hoverAccount, setHoverAccount] = useState(false);
  const [width, setWidth] = useState(window.innerWidth);
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 992);
  const [placeholderText, setPlaceholderText] = useState("Search by Category...");
  const [mobPlaceholderText, setMobPlaceholderText] = useState("");
  const [currentIndex, setCurrentIndex] = useState(0);

  const { login, dispatch } = useCartContext();
  const [storeData, setStoreData] = useState([]);
  const [filteredStores, setFilteredStores] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [isChecked, setIsChecked] = useState(false);
  const [count, setCount] = useState([]);
  const [lists, setLists] = useState([
    "gold", "silver", "diamond", "platinum"
  ]);
  const [CategoryList, setCategory] = useState(CATEGORY_lIST);

  const [state, setState] = useState({ isTechWalletEnable: false })
  const [listLoading, setListLoading] = useState(true);
  const [productType, setProductType] = useState([]);
  const [productSubCate, setProductSubCate] = useState([]);
  const [productCategory, setCategoryList] = useState([]);
  const [occationCate, setOccationCate] = useState([]);
  const [selectedList, setSelectedList] = useState({
    type: "",
    category: "",
    subCategory: "",
    gender: "",
    Price: "",
    status: "available",
  });
  const [hoveredType, setHoveredType] = useState(null);
  const [loadingCategories, setLoadingCategories] = useState(false);
  const [catitem, setCategoryItem] = useState('')
  const history = useNavigate()


  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // const containerStyle = {
  //   display: "flex",
  //   alignItems: "center",
  //   marginLeft: (width >= 768 && width <= 1439) ? "450px" : (width < 768 ? "70px" : "0px"),
  //   marginBottom: (width >= 768 && width <= 1439) ? "3rem" : "0",
  // };

  // const handleUseCurrentLocation = () => {
  //   setShowMap(true);
  // };

  const checkLogin = () => {
    if (getCustomerId()) {
      navigate("/MyScheme");
    } else {
      navigate("/LoginPage");
    }
  };

  const logout = () => {
    removeCustomerId();
    dispatch({ type: "LOGIN", payload: null });
    dispatch({ type: "ADD", payload: null });
    reactLocalStorage.remove("CartList");
    toast.success("Logged out successfully...!", {
      duration: 1000,
      position: "top-right",
    });
    setTimeout(() => {
      navigate("/");
    }, 1000);
  };

  useEffect(() => {
    getProductRate();
    getAddToCartDetails();
    getAllBrachDetails();
    getCategoryList('');
    getProductType();
    getProductType1();
    getProductType2();
    getProductSub();
    getOurExclusiveData();
  }, []);

  const getAllBrachDetails = () => {
    getAllBranch({}).then((data) => {
      setStoreData(data.response.content);
    });
  };

  const getProductRate = async () => {
    let fromDate = moment().startOf("day").format("YYYY-MM-DD HH:mm:ss");
    let toDate = moment().endOf("day").format("YYYY-MM-DD HH:mm:ss");
    const filterData = {
      branch: getBranchId(),
      createdAtFrom: filterFormatFromDate(fromDate),
      createdAtTo: filterFormatToDate(toDate),
    };
    const todayMetalRate = await PurityApi(filterData);
    if (todayMetalRate.errorCode === undefined) {
      let isGoldRateFound = false;
      let isSilverRateFound = false;
      let isGold18KRateFound = false;
      todayMetalRate.response.forEach((item) => {
        if (
          item.metaProdTypeName &&
          item.metaProdTypeName.toLowerCase() === "gold" &&
          item.purity.includes("22") &&
          !isGoldRateFound
        ) {
          item.purity = "22K";
          setRecentGoldRate(item);
          isGoldRateFound = true;
        } else if (
          item.metaProdTypeName &&
          item.metaProdTypeName.toLowerCase() === "gold" &&
          item.purity.includes("18") &&
          !isGold18KRateFound
        ) {
          item.purity = "18K";
          isGold18KRateFound = true;
        } else if (
          item.metaProdTypeName &&
          item.metaProdTypeName.toLowerCase() === "silver" &&
          !isSilverRateFound
        ) {
          setRecentSilverRate(item);
          isSilverRateFound = true;
        }
      });
    }
  };

  const [prevScrollPos, setPrevScrollPos] = useState(0);
  const [visible, setVisible] = useState(true);

  const handleScroll = () => {
    const currentScrollPos = window.scrollY;

    if (currentScrollPos > prevScrollPos) {
      setVisible(false);
    } else {
      setVisible(true);
    }

    setPrevScrollPos(currentScrollPos);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  });

  const purityRate = (
    // <div
    //   style={{ fontSize: "13px", fontWeight: 500, maxWidth: "fit-content" }}>
    //   <div className="d-flex align-items-center gap-2 mb-1">
    //     <i className="bi bi-server text-warning" style={{ fontSize: "16px" }}></i>
    //     <span style={{ fontWeight: 600 }}>{recentGoldRate.metaProdTypeName}</span>
    //     <span>
    //       {recentGoldRate?.onlineRate > 0
    //         ? `₹ ${recentGoldRate.onlineRate}`
    //         : recentGoldRate?.rate !== "N/A"
    //           ? `₹ ${recentGoldRate.rate}`
    //           : ""}
    //     </span>
    //     <span>{recentGoldRate.unitType ? ` /${recentGoldRate.unitType}` : ""}</span>
    //   </div>'
    // </div>
    ''
  );

  const [viewCart, setViewCart] = useState([]);
  const [total, setTotal] = useState([]);
  const [showModal, setShowModal] = useState("");

  useEffect(() => {
    viewCartList();
  }, [data, branchId]);

  const { dispatch: cartDispatch, dayClosed } = useCartContext();

  const viewCartList = () => {
    let dataList = [];
    let basePrice = 0;
    let total = 0;
    let cgst = 0;
    let sgst = 0;

    const newArray =
      getAddToCart() &&
        JSON.parse(getAddToCart()).filter(
          (cartItem) => cartItem.branchId === getBranchId()
        )
        ? getAddToCart() &&
        JSON.parse(getAddToCart()).filter(
          (cartItem) => cartItem.branchId === getBranchId()
        )
        : [];
    newArray &&
      newArray.forEach((element, index) => {
        let filter = {
          branch: getBranchId(),
          id: element.id,
          beforeCreatedAt: dayClosed,
        };
        const respData = getProduct(10, filter);
        respData.then((res) => {
          const productDataResponse = res.response.content;
          productDataResponse.forEach((item) => {
            dataList.push(item);
          });
          if (dataList.length - 1 === index) {
            if (dataList[index] !== undefined) {
              if (dataList[index].basePrice) {
                basePrice += Number(dataList[index].basePrice);
              }
              if (dataList[index].total) {
                total += Number(dataList[index].total);
              }
              if (dataList[index].saleTaxList[1].amount) {
                cgst += Number(dataList[index].saleTaxList[1].amount);
              }
              if (dataList[index].saleTaxList[0].amount) {
                sgst += Number(dataList[index].saleTaxList[0].amount);
              }
              let totalCartAmount = 0;
              let totalAmount;
              if (dataList?.length > 0) {
                totalAmount = dataList.reduce((result, item) => {
                  return (result += Math.trunc(item.total));
                }, 0);
              }
              totalCartAmount = totalAmount;
              setTotal(totalAmount);
              setViewCart(dataList);
            }
          }
        });
      });
    if (newArray.length === 0) {
      setViewCart(newArray);
    }
  };

  const removeItemFromCart = (code) => {
    let productData = JSON.parse(getAddToCart());
    const result = productData.filter((item) => item.productCode !== code);
    if (result) {
      reactLocalStorage.set("CartList", JSON.stringify(result));
      cartDispatch({ type: "ADD", payload: result });
      setViewCart(result);
      let dataList = [];
      let basePrice = 0;
      let total = 0;
      let cgst = 0;
      let sgst = 0;
      result &&
        result.forEach((element, index) => {
          dataList.push(element);
          if (dataList[index].basePrice) {
            basePrice += Number(
              dataList[index].basePrice +
              dataList[index].gemTotal +
              dataList[index].diamondTotal
            );
          }
          if (dataList[index].total) {
            total += Number(dataList[index].total);
          }
          if (dataList[index].saleTaxList[1].amount) {
            cgst += Number(dataList[index].saleTaxList[1].amount);
          }
          if (dataList[index].saleTaxList[0].amount) {
            sgst += Number(dataList[index].saleTaxList[0].amount);
          }
          let totalAmount = 0;
          if (dataList.length > 0) {
            totalAmount = dataList.reduce((result, item) => {
              return (result += Math.trunc(item.total));
            }, 0);
          }
          setTotal(totalAmount);
        });
      setViewCart(dataList);
      toast.success("Product Removed From the Cart !", {
        duration: 3000,
        position: "top-right",
      });
      setShowModal("");
    }
  };

  const CurrentPath = () => {
    if (data && data.length > 0) {
      navigate("/CartPage", { state: { viewCart } });
    }
  };

  const getAddToCartDetails = async () => {
    let filter = "savings_scheme_app";
    ECommerce(filter).then((data) => {
      let showButton = JSON.parse(data.response.moduleField);
      let isShowData = showButton.filter(
        (item) => item.key === "IS_ECOMM_ADD_TO_CART_ENABLED"
      );
      setIsShow(isShowData[0]?.value);
    });
  };

  const cart = (
    <div className="position-relative order-0 order-sm-3 p-0 mt-4 hover-trigger" style={{ position: "absolute", bottom: 30, right: 30 }}>
      <div className="d-flex flex-row flex-wrap justify-content-end align-items-center gap-4 mt-0" style={{ marginLeft: "-5px", marginTop: "-10px", }}>
        <span
          className="text-black mb-2 cart-icon"
          tw="cursor-pointer"
          onClick={CurrentPath}
        >
          <Link to="/CartPage" style={{ textDecoration: "none" }}>
            <div style={{ display: "flex", alignItems: "center", flexDirection: "column" }}>
              <div
                className="mt-4 p-0"
                style={{
                  border: "2px solid #f0b917",
                  width: "40px",
                  height: "40px",
                  borderRadius: "34px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                }}
              >
                <img src={cartImg} alt="Cart" style={{ width: "20px", marginLeft: '6px' }} />
              </div>

              <div
                style={{
                  textAlign: "center",
                  fontSize: "14px",
                  color: "#000",
                  fontFamily: "sans-serif",
                }}
              >
                Cart
              </div>
            </div>
          </Link>

          {data && data.length > 0 ? (
            <span
              className="mt-4 position-absolute top-0 start-100 translate-middle badge rounded-pill bg-warning"
              tw="bg-custom-100"
              style={{
                padding: "2px 6px",
                lineHeight: "16px",
              }}
            >
              {data?.length}
            </span>
          ) : JSON.parse(getAddToCart() !== undefined ? getAddToCart() : "[]").length > 0 ? (
            <span
              className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-warning"
              tw="bg-custom-100"
              style={{
                padding: "2px 6px",
                lineHeight: "16px",
                marginTop: "10px",
              }}
            >
              {JSON.parse(getAddToCart() !== undefined ? getAddToCart() : "[]").length}
            </span>
          ) : null}
        </span>
      </div>
      <div className="position-absolute end-0 py-3 bg-white rounded border hover-target header-cart"
        tw="w-96  rounded-lg duration-1000"
        style={{
          top: "80px",
          right: 0,
        }}
      >
        <div className="d-flex justify-content-between px-3">
          <CartTitle> MY SHOPPING BAG </CartTitle>
          <span tw="text-xs tracking-widest">
            {data && data.length > 0
              ? data.filter((cartItem) => cartItem.branchId === getBranchId())
                .length
              : JSON.parse(getAddToCart() !== undefined ? getAddToCart() : "[]")
                .length}{" "}
            Item
          </span>
        </div>
        <hr />
        {viewCart.length > 0 ? (
          <div className="main-content">
            {viewCart.map((list, index) => (
              <>
                <div className="row w-100 m-0 pb-3" key={index}>
                  <div className="col-md-3">
                    {" "}
                    <img style={{ width: 70 }}
                      src={
                        list.images.includes("@#@") && list.images !== "@#@"
                          ? list.images.split("@#@")[0]
                          : Noimg
                      }
                      alt="Jai Maruthi Jewellery"
                      className="border border-1"
                    />
                  </div>
                  <div className="col-md-6">
                    <p tw="text-sm mb-1">{list.title}</p>
                    <span
                      className="border-bottom text-black"
                      tw="text-xs cursor-pointer"
                      onClick={() => setShowModal(list.skv)}
                    >
                      Remove
                    </span>
                  </div>
                  <div className="col-md-3">
                    <p tw="text-sm tracking-wide ">
                      ₹{list.total && Math.trunc(list.total)}
                    </p>
                  </div>
                </div>
              </>
            ))}
            <div
              className="d-flex w-100 justify-content-between align-items-center"
              tw=" py-3 px-4 border border-r-0 border-l-0  border-gray-500 border-dashed "
            >
              <span tw="text-sm">Bag Subtotal </span>:
              <span tw="text-base text-custom-100 font-semibold">
                {" "}
                ₹ {total ? Math.trunc(total) : 0}
              </span>
            </div>
            <div className=" col-10  m-auto " tw="pt-5">
              <Link id="holder" to="/CartPage" tw="no-underline" />
              <div
                className="button"
                onClick={() =>
                  navigate("CartPage", { state: { viewCart } })}
              >
                <p style={{ background: " #f0b917" }}
                  className="btnText m-0 h-100 d-flex justify-content-center align-items-center">
                  <img src={white}></img><small>VIEW SHOPPING BAG</small>
                </p>
                <div className="btnTwo">
                  <p className="btnText2">
                    <i className="bi bi-handbag-fill"></i>
                    <img src={logo182}></img>
                  </p>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="col-md-12 empty-wrapper text-center">
            <img
              className="trash-icon m-auto w-50"
              alt="empty bag"
              src={logo182}
            />
            <h3 tw="mt-2 uppercase py-5 font-extrabold text-base">
              Oops! Your bag is empty!
            </h3>
          </div>
        )}
      </div>
    </div>
  );

  const handleImageClick = () => {
    navigate("/WishList");
  };

  const handleStoreIconClick = () => {
    navigate("/Store");
  };

  const handleCheckButtonClick = () => {
    if (!searchTerm.trim()) {
      setFilteredStores([]);
      setIsChecked(true);
      return;
    }
    const filteredStores = storeData.filter((store) => {
      const storePincode = store.branchAddress?.pincodeNumber;
      const storeCity = store.branchAddress?.city?.toLowerCase();
      const storeName = store.storeName?.toLowerCase();
      const storeAddress = store.branchAddress?.address1?.toLowerCase();
      const searchTermLower = searchTerm.toLowerCase();

      return (
        (storePincode && storePincode.includes(searchTerm)) ||
        (storeCity && storeCity.includes(searchTermLower)) ||
        (storeName && storeName.includes(searchTermLower)) ||
        (storeAddress && storeAddress.includes(searchTermLower))
      );
    });
    setFilteredStores(filteredStores);
    setIsChecked(true);
  };

  const [inputValue, setInputValue] = useState("");
  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };

  const handleNavigate = (selectedPrice) => {
    navigate('/ProductList', { state: { selectedPrice } });
  };

  const handleSearch = () => {
    if (!inputValue.trim()) {
      return;
    }
    const filteredProducts = productCategory.filter((data) =>
      data.categoryName.toLowerCase().includes(inputValue.toLowerCase())
    );

    if (filteredProducts.length > 0) {
      navigate(`/ProductList?category=${filteredProducts[0].id}`, {
        state: { category: filteredProducts[0] },
      });
    }
  };

  const handleTypeHover = (type) => {
    if (type !== null) {
      setLoadingCategories(false);
      getCategoryList(type);
    }
    setHoveredType(type);
  };

  const getProductSub = async (category) => {
    setListLoading(true);
    let visibilityList = [];
    let finalData = [];
    let filterData = {
      metaProdTypeEnty: selectedList.type ? selectedList.type : "",
      metaProdCateEnty: selectedList.category ? selectedList.category : category?.id,
    };
    if (filterData.metaProdTypeEnty === "") {
      delete filterData.metaProdTypeEnty;
    }
    if (filterData.metaProdCateEnty === "") {
      delete filterData.metaProdCateEnty;
    }
    await getAllProductSubCate(filterData).then((data) => {
      let response = data.response

      let limitedData = response.slice(0, 300);
      visibilityList = response.filter(
        (item) =>
          item.visibilityMode === "WEB_MOBILE" ||
          item.visibilityMode === "MOBILE"
      );

      if (category?.categoryName.toUpperCase() === "NECKLACES") {
        const allowedNames = ["cz necklace", "polki", "nakas", "beads"];

        finalData = limitedData.filter(item =>
          allowedNames.some(name =>
            item.subCategoryName?.toLowerCase().includes(name.toLowerCase())
          )
        );
      }
      else if (category?.categoryName.toUpperCase() === "PENDANTS") {
        const allowedNames = ["cz", "polki", "stone"];

        finalData = limitedData.filter(item =>
          allowedNames.some(name =>
            item.subCategoryName?.toLowerCase().includes(name.toLowerCase())
          )
        );
      }
      else {
        finalData = limitedData;
      }
      setProductSubCate(finalData);
      setListLoading(false);
    });
  };

  const getCategoryList = async (type) => {
    setListLoading(true);
    let visibilityList = [];
    let categoryTypeList = [];
    let filterData = {
      metaProdTypeEnty: selectedList.type ? selectedList.type : "",
    };
    if (filterData.metaProdTypeEnty === "") {
      delete filterData.metaProdTypeEnty;
    }
    await getAllProductCate(filterData)?.then((data) => {
      const productResponse = data.response;
      productResponse?.forEach(
        item => {
          if (item.categoryName.toLowerCase() === type.toLowerCase()) {
            categoryTypeList.push({
              categoryName: item.categoryTypeList,
              categoryId: item.id,
              productTypeId: item.metaProdTypeId
            })
            getProductSub(item);
            setCategoryItem(item);
          }
        }
      )
      visibilityList = productResponse?.filter(
        (item) =>
          item.visibilityMode === "WEB_MOBILE" ||
          item.visibilityMode === "MOBILE"
      );
      setCategoryList(visibilityList);
      setListLoading(false);
    });
  };

  const getOurExclusiveData = () => {
    getProductCate({
      visibilityMode: "DESIGN",
    })
      .then((data) => {
        setOccationCate(data.response.content);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const getProductCount = (productId) => {
    let filter = {
      visibilityMode: "MOBILE" || "WEB",
      productType: productId,
      allowCatalogue: 1,
    };
    ProductCateCountApi(filter).then((data) => {
      setCount(data.response);
    });
  };

  const getProductType2 = () => {
    getPageProductType({}).then((data) => {
      let response = data.response.content;
      let filterData = response.filter((data) => {
        if (data.metaProductCategoryList.length > 0) {
          const typeName = data.name.toLowerCase().trim();
          return (
            typeName === "gold" ||
            typeName === "silver" ||
            typeName === "silver articles" ||
            typeName === "diamond" ||
            typeName === "platinum"
          );
        }
        else {
          return false
        }
      });
      filterData.reverse()
      setStoreData(filterData);
    });
  };

  const getProductType = async () => {
    let pList = [];
    setListLoading(true);
    await getPageProductType({ active: 1 }).then((data) => {
      setListLoading(true);
      productType.length = 0;
      let response = data.response.content;
      pList = response.filter(
        (data) => data.metaProductCategoryList.length > 0 && data.id
      );
      pList.reverse();
      for (let index = 0; index < pList.length; index++) {
        productType.push(pList[index]);
      }
      setProductType(productType);
      setListLoading(false);
    });
  };

  const getProductType1 = () => {
    const arr1 = [];
    const arr2 = [];
    let isChecked = false
    let equlprod = []
    let notEqulprod = []

    let filterData = {
      active: 1
    }
    getPageProductType(filterData).then((data) => {
      let response = data.response.content;
      lists.forEach((item, idx) => {
        if (!isChecked) {
          equlprod.length = 0
          arr1.push(...response.filter((x) => x.name.toLowerCase() === item))
          arr2.push(...response.filter((x) => x.name.toLowerCase() !== item))
          isChecked = true
        } else {
          arr1.push(...arr2.filter((x) => x.name.toLowerCase() === item))
          const newarr = arr2
          notEqulprod = newarr.filter((x) => (x.name).toLowerCase() !== item)
          arr2.length = 0
          arr2.push(...notEqulprod)
        }
        if (lists.length - 1 === idx) {
          arr1.push(...arr2)
        }
      })
      const pageData = response.reverse()
      let cropDatas = pageData.slice(0, 5)
      let cropData = arr1.slice(0, 6)
      setStoreData(cropData);
      setStoreData(cropDatas);
    })
  }


  const searchQueries = ["Stud", "Chain", "Bracelets", "Necklace",
    "Mangalsutras", "Earrings"];
  const [queryIndex, setQueryIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setQueryIndex((prevIndex) => (prevIndex + 1) % searchQueries.length);
    }, 2000);
    return () => clearInterval(interval);
  }, [searchQueries.length]);

  useEffect(() => {
    if (productCategory.length > 0) {
      const intervalId = setInterval(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % productCategory.length);
      }, 2000);

      return () => clearInterval(intervalId);
    }
  }, [productCategory]);

  useEffect(() => {
    if (productCategory.length > 0) {
      const categoryName = productCategory[currentIndex].categoryName.toLowerCase();
      setPlaceholderText(`Search By ${categoryName.charAt(0).toUpperCase() + categoryName.slice(1)}`);
      setMobPlaceholderText(categoryName.charAt(0).toUpperCase() + categoryName.slice(1))
    } else {
      setPlaceholderText("Search By Category...");
      setMobPlaceholderText("Search By Category...")
    }
  }, [currentIndex, productCategory]);

  const handleChange = (e) => {
    let target = e.target;
    let input = target.name;
    let value = target.value;
    let index = e.nativeEvent.target.selectedIndex;
    let text = e.nativeEvent.target[index].text;

    if (input === "type") {
      setSelectedList({
        ...selectedList,
        type: value,
        category: "",
        subCategory: "",
        typeName: text,
        categoryName: "",
        subCategoryName: "",
      });
    } else if (input === "category") {
      setSelectedList({
        ...selectedList,
        category: value,
        subCategory: "",
        categoryName: text,
        subCategoryName: "",
      });
    } else if (input === "subCategory") {
      setSelectedList({
        ...selectedList,
        subCategory: value,
        subCategoryName: text,
      });
    } else if (input === "gender") {
      setSelectedList({
        ...selectedList,
        gender: value,
        genderName: text,
      });
    } else if (input === "status") {
      setSelectedList({
        ...selectedList,
        status: value,
        statusName: text,
      });
    }
    else if (input === "price") {
      setSelectedList({
        ...selectedList,
        status: value,
        statusName: text,
      });
    }
  };

  const navigateMyaddress = () => {
    history("/AddAddress", { state: { state, fromAccount: fromAccount } })
  }

  return (
    <>
      {/* <div className={modalOpened ? 'blur-background' : ''}> */}
      <Toaster position="top-right" />
      <Link to="/" className="d-flex align-items-center">

        <img
          src={Logo}
          alt="Jai Maruthi Jewellery"
          className={`d-none d-md-block img-fluid${visible ? "sticky-top" : ""}`}

        />

        <img
          src={Logo}
          alt="Jai Maruthi Jewellery Mobile"
          className={`d-block d-md-none img-fluid${visible ? "sticky-top" : ""}`}
          style={{ objectFit: "contain" , width: "550px" }}
        />

      </Link>

      <nav
        tw="z-30"
      >
        <div className="container-fluid">

          <div className="container-fluid px-0">

            <div className="bg-white border-bottom">

              {/* DESKTOP VIEW  (unchanged UI) */}
              <div className={`d-none d-md-flex align-items-center ${visible ? "sticky-top" : ""}`} style={{
                background: "#fff",
                boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
                position: "relative",
                zIndex: "50",  // CHANGED: Reduced from 100 to 50
                padding: "12px 20px",
                minHeight: "70px"
              }}>
                <div className="d-flex flex-grow-1 align-items-center justify-content-between" style={{ gap: "20px" }}>

                  {/* Left Section - Offers & Scheme */}
                  <div className="d-flex align-items-center flex-shrink-0" style={{
                    gap: "clamp(15px, 2vw, 30px)",
                    minWidth: "200px"
                  }}>
                    {/* Offers Button */}
                    <div className="flex-shrink-0">
                      <a href="/Offers" className="text-decoration-none">
                        <button
                          style={{
                            border: "1px solid #aa8106ff",
                            background: "linear-gradient(to right, #daab20, #f5ba09ff)",
                            borderRadius: "8px",
                            width: "clamp(100px, 10vw, 120px)",
                            height: "44px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "6px",
                            fontSize: "clamp(12px, 1.5vw, 14px)",
                            fontWeight: "bold",
                            color: "#000",
                            cursor: "pointer",
                            transition: "all 0.3s ease"
                          }}
                          onMouseEnter={(e) => e.currentTarget.style.transform = "scale(1.05)"}
                          onMouseLeave={(e) => e.currentTarget.style.transform = "scale(1)"}
                        >
                          <img
                            src={log2}
                            alt="Offers"
                            style={{
                              width: "clamp(16px, 2vw, 20px)",
                              height: "clamp(16px, 2vw, 20px)"
                            }}
                          />
                          OFFERS
                        </button>
                      </a>
                    </div>

                    {/* Saving Scheme */}
                    <div className="d-flex align-items-center flex-shrink-0">
                      <Link
                        to="/SchemeList"
                        className="d-flex align-items-center text-dark text-decoration-none"
                        style={{
                          gap: "8px",
                          padding: "8px 12px",
                          borderRadius: "6px",
                          transition: "all 0.3s ease"
                        }}
                        onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#fef9e7"}
                        onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "transparent"}
                      >
                        <img
                          src={schemeImage}
                          alt="Saving Scheme"
                          style={{ width: "clamp(20px, 3vw, 25px)" }}
                        />
                        <span
                          className="fw-medium"
                          style={{
                            fontSize: "clamp(12px, 1.5vw, 14px)",
                            whiteSpace: "nowrap"
                          }}
                        >
                          Saving Scheme
                        </span>
                      </Link>
                    </div>
                  </div>

                  {/* Middle Section - Search Bar */}
                  <div
                    className="d-none d-lg-flex align-items-center justify-content-center"
                    style={{
                      flex: "1",
                      minWidth: "250px",
                      maxWidth: "600px",
                      position: "relative"
                    }}
                  >
                    <div className="position-relative w-100" style={{ maxWidth: "500px" }}>
                      <input
                        type="text"
                        className="form-control"
                        value={inputValue}
                        onChange={handleInputChange}
                        onKeyDown={handleKeyPress}
                        placeholder={placeholderText}
                        style={{
                          fontSize: "clamp(12px, 1.5vw, 14px)",
                          padding: "10px 45px 10px 15px",
                          height: "44px",
                          borderRadius: "8px",
                          width: '100%',
                          border: "2px solid #f0b917",
                          backgroundColor: "#fff",
                          boxShadow: "0 2px 8px rgba(240, 185, 23, 0.2)",
                          transition: "all 0.3s ease"
                        }}
                        onFocus={(e) => {
                          e.target.style.boxShadow = "0 2px 12px rgba(240, 185, 23, 0.4)";
                          e.target.style.borderColor = "#d4a017";
                        }}
                        onBlur={(e) => {
                          e.target.style.boxShadow = "0 2px 8px rgba(240, 185, 23, 0.2)";
                          e.target.style.borderColor = "#f0b917";
                        }}
                      />
                      <button
                        style={{
                          position: "absolute",
                          right: "12px",
                          top: "50%",
                          transform: "translateY(-50%)",
                          cursor: "pointer",
                          fontSize: "clamp(16px, 2vw, 18px)",
                          color: "#f0b917",
                          border: "none",
                          background: "transparent",
                          width: "30px",
                          height: "30px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          transition: "all 0.3s ease"
                        }}
                        onClick={handleSearch}
                        onMouseEnter={(e) => e.currentTarget.style.color = "#d4a017"}
                        onMouseLeave={(e) => e.currentTarget.style.color = "#f0b917"}
                      >
                        <i className="bi bi-search"></i>
                      </button>
                    </div>
                  </div>

                  {/* Right Section - Account, Wishlist, Cart */}
                  <div
                    className="d-flex align-items-center flex-shrink-0"
                    style={{
                      gap: "clamp(15px, 2vw, 30px)",
                      minWidth: "fit-content",
                      justifyContent: "flex-end"
                    }}
                  >
                    {/* Account */}
                    <div
                      className="text-center position-relative"
                      onMouseEnter={() => setHoverAccount(true)}
                      style={{
                        cursor: "pointer",
                        minWidth: "clamp(60px, 8vw, 70px)"
                      }}
                    >
                      <div
                        style={{
                          border: "2px solid #f0b917",
                          width: "clamp(40px, 6vw, 45px)",
                          height: "clamp(40px, 6vw, 45px)",
                          borderRadius: "50%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          margin: "0 auto",
                          backgroundColor: hoverAccount ? "#fef9e7" : "#fff",
                          transition: "all 0.3s ease"
                        }}
                      >
                        <img
                          src={accountImg}
                          alt="Account"
                          style={{
                            width: "clamp(18px, 3vw, 22px)",
                            transition: "transform 0.3s ease",
                            transform: hoverAccount ? "scale(1.1)" : "scale(1)"
                          }}
                        />
                      </div>
                      <div style={{
                        fontSize: "clamp(11px, 1.5vw, 13px)",
                        marginTop: "5px",
                        fontWeight: "500",
                        color: hoverAccount ? "#d4a017" : "#333",
                        transition: "color 0.3s ease"
                      }}>
                        Account
                      </div>

                      {hoverAccount && (
                        <div
                          className="position-absolute bg-white shadow-lg rounded p-2"
                          style={{
                            top: "calc(100% + 8px)",
                            right: "0",
                            minWidth: "180px",
                            zIndex: "1000",
                            border: "1px solid #eee",
                            animation: "fadeIn 0.2s ease"
                          }}
                          onMouseEnter={() => setHoverAccount(true)}
                          onMouseLeave={() => setHoverAccount(false)}
                        >
                          {login ? (
                            <>
                              <div className="border-bottom text-center pb-2 fw-bold" style={{
                                color: "#aa8106ff",
                                fontSize: "14px",
                                padding: "5px"
                              }}>
                                {getCustomerName()}
                              </div>
                              <span
                                onClick={() => {
                                  checkLogin();
                                  setHoverAccount(false);

                                }}
                                className="d-block py-2 px-2 text-dark text-decoration-none hover-bg"
                                style={{ transition: "all 0.2s ease" }}
                              >
                                <i className="bi bi-person-workspace me-2"></i> My Scheme
                              </span>
                              <Link
                                to="/MyPurchase"
                                className="d-block py-2 px-2 text-dark text-decoration-none hover-bg"
                                onClick={() => setHoverAccount(false)}
                                style={{ transition: "all 0.2s ease" }}
                              >
                                <i className="bi bi-bag me-2"></i> My Purchase
                              </Link>
                              <Link
                                to="/AddAddress"
                                className="d-block py-2 px-2 text-dark text-decoration-none hover-bg"
                                onClick={() => setHoverAccount(false)}
                                style={{ transition: "all 0.2s ease" }}
                              >
                                <i className="bi bi-geo-alt-fill me-2"></i> My Address
                              </Link>
                              <span
                                onClick={() => {
                                  logout();
                                  setHoverAccount(false);
                                }}
                                className="d-block py-2 px-2 text-dark text-decoration-none hover-bg"
                                style={{ transition: "all 0.2s ease" }}
                              >
                                <i className="bi bi-box-arrow-in-left me-2"></i> Logout
                              </span>
                            </>
                          ) : (
                            <span
                              onClick={() => {
                                dispatch({ type: "MODAL", payload: "login" });
                                setHoverAccount(false);
                                setModalOpened(true);
                              }}
                              className="d-block py-2 px-2 text-dark text-decoration-none hover-bg"
                              style={{ transition: "all 0.2s ease" }}
                            >
                              <i className="bi bi-box-arrow-in-right me-2"></i> Login
                            </span>
                          )}
                        </div>
                      )}
                    </div>

                    {/* Wishlist */}
                    <div className="text-center" style={{ minWidth: "clamp(60px, 8vw, 70px)" }}>
                      <Link to="/WishList" className="text-decoration-none text-dark">
                        <div
                          style={{
                            border: "2px solid #f0b917",
                            width: "clamp(40px, 6vw, 45px)",
                            height: "clamp(40px, 6vw, 45px)",
                            borderRadius: "50%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            margin: "0 auto",
                            backgroundColor: "#fff",
                            transition: "all 0.3s ease"
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = "#fef9e7";
                            e.currentTarget.style.transform = "scale(1.05)";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = "#fff";
                            e.currentTarget.style.transform = "scale(1)";
                          }}
                        >
                          <img
                            src={wishlistImg}
                            alt="Wishlist"
                            style={{
                              width: "clamp(18px, 3vw, 22px)",
                              transition: "transform 0.3s ease"
                            }}
                          />
                        </div>
                        <div style={{
                          fontSize: "clamp(11px, 1.5vw, 13px)",
                          marginTop: "5px",
                          fontWeight: "500",
                          transition: "color 0.3s ease"
                        }}>
                          Wishlist
                        </div>
                      </Link>
                    </div>

                    {/* Cart */}
                    <div className="text-center position-relative" style={{
                      minWidth: "clamp(60px, 8vw, 70px)",
                      cursor: "pointer"
                    }}>
                      <Link to="/CartPage" className="text-decoration-none text-dark">
                        <div
                          style={{
                            border: "2px solid #f0b917",
                            width: "clamp(40px, 6vw, 45px)",
                            height: "clamp(40px, 6vw, 45px)",
                            borderRadius: "50%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            margin: "0 auto",
                            backgroundColor: "#fff",
                            position: "relative",
                            transition: "all 0.3s ease"
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = "#fef9e7";
                            e.currentTarget.style.transform = "scale(1.05)";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = "#fff";
                            e.currentTarget.style.transform = "scale(1)";
                          }}
                        >
                          <img
                            src={cartImg}
                            alt="Cart"
                            style={{
                              width: "clamp(18px, 3vw, 22px)",
                              transition: "transform 0.3s ease"
                            }}
                          />
                        </div>
                        <div style={{
                          fontSize: "clamp(11px, 1.5vw, 13px)",
                          marginTop: "5px",
                          fontWeight: "500",
                          transition: "color 0.3s ease"
                        }}>
                          Cart
                        </div>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>

              {/* MOBILE VIEW  */}
              <div className="d-flex flex-column gap-2 d-block d-md-none">
                <div className="d-flex flex-column gap-3 p-3" style={{
                  background: "linear-gradient(135deg, #fff9e6 0%, #fff 100%)",
                  borderRadius: "12px",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.1)"
                }}>
                  {/* First Line: Offers, Scheme & Search */}
                  <div className="d-flex align-items-center justify-content-between flex-row" style={{ gap: "clamp(8px, 3vw, 12px)" }}>
                    {/* Offers Button */}
                    <a href="/Offers" className="text-decoration-none flex-shrink-0">
                      <button
                        style={{
                          border: "2px solid #aa8106",
                          background: "linear-gradient(135deg, #daab20, #f5ba09)",
                          borderRadius: "10px",
                          width: "clamp(36px, 10vw, 44px)",
                          height: "clamp(44px, 12vw, 52px)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: "clamp(4px, 1vw, 8px)",
                          fontSize: "clamp(13px, 3.5vw, 15px)",
                          fontWeight: "700",
                          color: "#000",
                          boxShadow: "0 4px 8px rgba(170, 129, 6, 0.3)",
                          transition: "all 0.3s ease"
                        }}
                        className="btn-hover"
                      >
                        <i className="bi bi-gift-fill" style={{ fontSize: "clamp(16px, 4vw, 18px)" }}></i>
                      </button>
                    </a>

                    {/* Search Bar - Takes remaining space */}
                    <div className="flex-grow-1" style={{ minWidth: "0" }}>
                      <div className="position-relative">
                        <input
                          type="text"
                          className="form-control"
                          value={inputValue}
                          onChange={handleInputChange}
                          onKeyDown={handleKeyPress}
                          placeholder={mobPlaceholderText}
                          style={{
                            fontSize: "clamp(13px, 3.5vw, 15px)",
                            padding: "clamp(10px, 2.5vw, 12px) clamp(12px, 3vw, 16px)",
                            height: "clamp(44px, 12vw, 52px)",
                            borderRadius: "10px",
                            border: "2px solid #f0b917",
                            boxShadow: "0 2px 8px rgba(240, 185, 23, 0.2)",
                            transition: "all 0.3s ease"
                          }}
                          onFocus={(e) => {
                            e.target.style.boxShadow = "0 2px 12px rgba(240, 185, 23, 0.4)";
                            e.target.style.borderColor = "#aa8106";
                          }}
                          onBlur={(e) => {
                            e.target.style.boxShadow = "0 2px 8px rgba(240, 185, 23, 0.2)";
                            e.target.style.borderColor = "#f0b917";
                          }}
                        />
                        <button
                          style={{
                            position: "absolute",
                            right: "clamp(8px, 2vw, 12px)",
                            top: "50%",
                            transform: "translateY(-50%)",
                            cursor: "pointer",
                            fontSize: "clamp(18px, 4.5vw, 20px)",
                            color: "#aa8106",
                            border: "none",
                            background: "transparent",
                            transition: "all 0.2s ease",
                            width: "clamp(28px, 8vw, 32px)",
                            height: "clamp(28px, 8vw, 32px)",
                            borderRadius: "50%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center"
                          }}
                          onClick={handleSearch}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.background = "#f0b917";
                            e.currentTarget.style.color = "#000";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.background = "transparent";
                            e.currentTarget.style.color = "#aa8106";
                          }}
                        >
                          <i className="bi bi-search"></i>
                        </button>
                      </div>
                    </div>

                    {/* Saving Scheme Icon */}
                    <div className="flex-shrink-0">
                      <Link
                        to="/SchemeList"
                        className="text-decoration-none text-dark flex-shrink-0"
                        style={{
                          transition: "transform 0.3s ease"
                        }}
                        onMouseEnter={(e) => e.currentTarget.style.transform = "scale(1.1)"}
                        onMouseLeave={(e) => e.currentTarget.style.transform = "scale(1)"}
                      >
                        <div style={{
                          width: "clamp(44px, 12vw, 52px)",
                          height: "clamp(44px, 12vw, 52px)",
                          borderRadius: "50%",
                          background: "linear-gradient(135deg, #f5ba09, #daab20)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          boxShadow: "0 2px 6px rgba(170, 129, 6, 0.3)"
                        }}>
                          <i className="bi bi-piggy-bank-fill text-white" style={{ fontSize: "clamp(18px, 5vw, 22px)" }}></i>
                        </div>
                      </Link>
                    </div>
                  </div>

                  {/* Second Line: Account, Wishlist & Cart */}
                  <div className="d-flex justify-content-between align-items-center flex-row" style={{ gap: "clamp(8px, 3vw, 12px)" }}>
                    {/* Account */}
                    <div className="text-center action-item flex-fill">
                      <div
                        style={{
                          border: "2px solid #f0b917",
                          width: "clamp(44px, 12vw, 56px)",
                          height: "clamp(44px, 12vw, 56px)",
                          borderRadius: "50%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          margin: "0 auto",
                          background: "white",
                          boxShadow: "0 2px 8px rgba(240, 185, 23, 0.2)",
                          transition: "all 0.3s ease",
                          cursor: "pointer"
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.background = "linear-gradient(135deg, #f5ba09, #daab20)";
                          e.currentTarget.style.transform = "translateY(-3px)";
                          e.currentTarget.style.boxShadow = "0 4px 12px rgba(240, 185, 23, 0.4)";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.background = "white";
                          e.currentTarget.style.transform = "translateY(0)";
                          e.currentTarget.style.boxShadow = "0 2px 8px rgba(240, 185, 23, 0.2)";
                        }}
                      >
                        <i className="bi bi-person-fill" style={{ fontSize: "clamp(18px, 5vw, 22px)", color: "#aa8106" }}></i>
                      </div>
                      <div style={{
                        fontSize: "clamp(11px, 3vw, 13px)",
                        marginTop: "6px",
                        fontWeight: "600",
                        color: "#333",
                        transition: "all 0.3s ease"
                      }}>Account</div>
                    </div>

                    {/* Wishlist */}
                    <Link to="/WishList" className="text-decoration-none text-dark text-center action-item flex-fill">
                      <div
                        style={{
                          border: "2px solid #f0b917",
                          width: "clamp(44px, 12vw, 56px)",
                          height: "clamp(44px, 12vw, 56px)",
                          borderRadius: "50%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          margin: "0 auto",
                          background: "white",
                          boxShadow: "0 2px 8px rgba(240, 185, 23, 0.2)",
                          transition: "all 0.3s ease"
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.background = "linear-gradient(135deg, #f5ba09, #daab20)";
                          e.currentTarget.style.transform = "translateY(-3px)";
                          e.currentTarget.style.boxShadow = "0 4px 12px rgba(240, 185, 23, 0.4)";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.background = "white";
                          e.currentTarget.style.transform = "translateY(0)";
                          e.currentTarget.style.boxShadow = "0 2px 8px rgba(240, 185, 23, 0.2)";
                        }}
                      >
                        <i className="bi bi-heart-fill" style={{ fontSize: "clamp(16px, 4.5vw, 20px)", color: "#aa8106" }}></i>
                      </div>
                      <div style={{
                        fontSize: "clamp(11px, 3vw, 13px)",
                        marginTop: "6px",
                        fontWeight: "600",
                        color: "#333",
                        transition: "all 0.3s ease"
                      }}>Wishlist</div>
                    </Link>

                    {/* Cart */}
                    <Link to="/CartPage" className="text-decoration-none text-dark text-center action-item position-relative flex-fill">
                      <div
                        style={{
                          border: "2px solid #f0b917",
                          width: "clamp(44px, 12vw, 56px)",
                          height: "clamp(44px, 12vw, 56px)",
                          borderRadius: "50%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          margin: "0 auto",
                          background: "white",
                          boxShadow: "0 2px 8px rgba(240, 185, 23, 0.2)",
                          transition: "all 0.3s ease"
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.background = "linear-gradient(135deg, #f5ba09, #daab20)";
                          e.currentTarget.style.transform = "translateY(-3px)";
                          e.currentTarget.style.boxShadow = "0 4px 12px rgba(240, 185, 23, 0.4)";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.background = "white";
                          e.currentTarget.style.transform = "translateY(0)";
                          e.currentTarget.style.boxShadow = "0 2px 8px rgba(240, 185, 23, 0.2)";
                        }}
                      >
                        <i className="bi bi-cart-fill" style={{ fontSize: "clamp(18px, 5vw, 22px)", color: "#aa8106" }}></i>
                      </div>
                      <div style={{
                        fontSize: "clamp(11px, 3vw, 13px)",
                        marginTop: "6px",
                        fontWeight: "600",
                        color: "#333",
                        transition: "all 0.3s ease"
                      }}>Cart</div>
                    </Link>
                  </div>

                  {/* CSS for hover effects */}
                  <style>
                    {`
        .btn-hover:hover {
          transform: translateY(-2px);
          box-shadow: 0 6px 12px rgba(170, 129, 6, 0.4) !important;
        }

        .action-item:hover div:last-child {
          color: #aa8106 !important;
        }
      `}
                  </style>
                </div>
              </div>

            </div>

            <div
              className="d-flex align-items-center justify-content-center position-relative p-3"
              onMouseLeave={() => setHoveredType(null)}
            >
              {CATEGORY_lIST && CATEGORY_lIST.map((type) => (
                <div
                  key={type}
                  className="position-relative d-inline-block"
                  style={{
                    marginLeft: "18px",
                    cursor: "pointer",
                  }}
                  onMouseEnter={() => handleTypeHover(type)}
                >
                  <div
                    className="candere-heading menu-item fw-bold"
                    style={{
                      padding: "8px 12px",
                      display: "inline-block",
                    }}
                  >
                    <Link
                      onClick={() => setHoveredType(null)}
                      to={`/ProductList?subCatagoryId=${catitem}`}
                      state={{ category: catitem }}
                      style={{
                        transition: "all 0.2s ease",
                        fontSize: "14px",
                        color: "black",
                        textDecoration: "none",
                      }} >
                      <span
                        className="fw-bold text-uppercase"
                        style={{
                          fontSize: "15px",
                          color: hoveredType === type ? "#f0b917" : "#000",
                          transition: "color 0.3s ease",
                        }}
                      >
                        {type}
                      </span>
                    </Link>
                    <div
                      className="position-absolute w-100"
                      style={{
                        height: "2px",
                        bottom: "0",
                        left: "0",
                        background: "#f0b917",
                        transform: hoveredType === type ? "scaleX(1)" : "scaleX(0)",
                        transition: "transform 0.3s ease",
                        transformOrigin: "center",
                      }}
                    />
                  </div>
                </div>
              ))}

              {hoveredType && isDesktop && (
                <div
                  className="bg-white shadow-lg border-top position-absolute"
                  style={{
                    top: "100%",
                    left: "50%",
                    transform: "translateX(-50%)",
                    width: "75vw",
                    padding: "50px 80px",
                    zIndex: 1200,
                    transition: "opacity 0.3s ease",
                  }}
                  onMouseEnter={() => setHoveredType(hoveredType)}
                  onMouseLeave={() => setHoveredType(null)}
                >
                  <div className="row text-center">
                    <div>
                      <div className="d-flex flex-column align-items-center mb-3">
                        <h6 className="fw-bold text-uppercase mb-2" style={{ fontSize: "14px" }}>
                          Shop by Subcategory
                        </h6>
                        <div
                          style={{
                            width: "60px",
                            height: "2px",
                            background: "#f0b917",
                          }}
                        ></div>
                      </div>
                      <div className="row g-2">
                        {productSubCate.map((cat) => (
                          <div key={cat.id} className="col-4">
                            <Link
                              onClick={() => setHoveredType(null)}
                              to={`/ProductList?subCatagoryId=${cat.id}`}
                              state={{ cat }}
                              className="d-block text-decoration-none text-center"
                              style={{
                                transition: "all 0.2s ease",
                                fontSize: "12px",
                                color: "black",
                                padding: "6px 4px",
                                border: "1px solid #dee2e6",
                                borderRadius: "4px",
                                backgroundColor: "white"
                              }}
                              onMouseEnter={(e) => {
                                e.currentTarget.style.color = "#f0b917";
                                e.currentTarget.style.backgroundColor = "#f8f9fa";
                                e.currentTarget.style.borderColor = "#f0b917";
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.color = "black";
                                e.currentTarget.style.backgroundColor = "white";
                                e.currentTarget.style.borderColor = "#dee2e6";
                              }}
                            >
                              <b>{cat.subCategoryName}</b>
                            </Link>
                          </div>
                        ))}
                      </div>
                    </div>

                    {/* <div className="col-lg-3 col-md-6">
                      <h6 className="fw-bold text-uppercase mb-3" style={{ fontSize: "14px" }}>
                        Shop by Type
                      </h6>
                      <div
                        className="mb-3"
                        style={{ width: "60px", height: "2px", background: "#f0b917" }}
                      ></div>
                      <div className="row">
                        {productType.map((data) => (
                          <div key={data.id} className="col-12 mb-2">
                            <Link
                              to={`/ProductList?type=${data.id}`}
                              className="text-decoration-none text-dark text-start d-block py-1 px-2 rounded"
                              style={{
                                transition: "all 0.2s ease",
                                fontSize: "14px",
                              }}
                              onMouseEnter={(e) => {
                                e.target.style.color = "#f0b917";
                                e.target.style.backgroundColor = "#f8f9fa";
                              }}
                              onMouseLeave={(e) => {
                                e.target.style.color = "black";
                                e.target.style.backgroundColor = "transparent";
                              }}
                            >
                              <b>{data.name}</b>
                            </Link>
                          </div>
                        ))}
                      </div>
                    </div> */}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </nav>

      {showModal && (
        <>
          <RemoveCart
            setShowModal={() => setShowModal("")}
            showModal={showModal}
            removeItemFromCart={removeItemFromCart}
          />
          <div tw="opacity-25 fixed inset-0 z-40 bg-black"></div>
        </>
      )}
      {/* </div> */}
    </>
  );


};

export default memo(forwardRef(MyComponent));